import { ReducersMapObject } from 'redux';
import { routerReducer } from 'react-router-redux';
import user, { UserState } from './reducers/user';
import signupUser, { SignupState } from './reducers/signupUser';
import environment, { EnvironmentState } from './environment/Environment';
import errorState, { ErrorState } from './reducers/errors';
import fileUpload, { FileUploadState } from './reducers/fileUpload';
import feedback, { FeedbackState } from './reducers/feedback';
import liveOrder, { LiveOrderState } from './reducers/liveorderfile';
import completeOrder, { CompleteOrderState } from './reducers/completeorderfile';
import forgotLink, { ForgotLinkState } from './reducers/forgotLink';
import forgotPassword, { ForgotPasswordState } from './reducers/forgot';
import userProfileData, { UserProfileState } from './reducers/userProfile';
import userAccountData, { UserAccountState } from './reducers/userAccount';
import UserOrderData, { UserOrderState } from './reducers/dashboard';
import UserRxFormData, { UserRxFormState } from './reducers/rxForm';
import supportRequest, { SupportRequestState } from './reducers/supportRequest';
import support, { SupportState } from './reducers/support';
import supportPage, { SupportPageState } from './reducers/supportPage';
import landingPage, { LandingPageState } from './reducers/landingPage';
import payment, { PaymentState } from './reducers/payment';
import paidInvoice, { PaidInvoiceState } from './reducers/paidinvoice';
import editDesignPreferences, { EditDesignPreferenceState } from './reducers/editDesignPreference';
import materialFiles, { MaterialFilesState } from './reducers/materialFiles';
import manufactur, { ManufacturState } from './reducers/manufactur';
import mfileupload, { MFileUploadState } from './reducers/mfileupload';
import feedbackRequest, { FeedbackStateList } from './reducers/feedbackRequest';

export const reducers: ReducersMapObject = {
    user,
    signupUser,
    userProfileData,
    userAccountData,
    UserOrderData,
    environment,
    errorState,
    fileUpload,
    feedback,
    liveOrder,
    completeOrder,
    forgotLink,
    forgotPassword,
    UserRxFormData,
    supportRequest,
    feedbackRequest,
    support,
    supportPage,
    landingPage,
    payment,
    paidInvoice,
    manufactur,
    editDesignPreferences,
    materialFiles,
    mfileupload,
    router: routerReducer,
};

export interface AppState {
    user: UserState;
    signupUser: SignupState;
    userProfileData: UserProfileState;
    userAccountData: UserAccountState;
    environment: EnvironmentState;
    errorState: ErrorState;
    fileUpload: FileUploadState;
    feedback: FeedbackState;
    liveOrder: LiveOrderState;
    completeOrder: CompleteOrderState;
    forgotLink: ForgotLinkState;
    forgotPassword: ForgotPasswordState;
    UserOrderData: UserOrderState;
    UserRxFormData: UserRxFormState;
    supportRequest: SupportRequestState;
    feedbackRequest: FeedbackStateList;
    support: SupportState;
    supportPage: SupportPageState;
    landingPage: LandingPageState;
    payment: PaymentState;
    paidInvoice: PaidInvoiceState;
    editDesignPreferences: EditDesignPreferenceState;
    materialFiles: MaterialFilesState;
    manufactur: ManufacturState;
    mfileupload: MFileUploadState;
}

export const emptyAppState: () => AppState = () => ({
    user: {
        userDetails: {
            s: '',
            ugroup: '',
            uroles: '',
            userName: '',
            userGroup: '',
            groupNo: '',
            email: '',
            nickName: '',
            userType: '',
            mobileNumber: '',
            allUserGroup: '',
            responsibilies: '',
            roleName: '',
            labCode: '',
            dmeRequired: ''
        }
    },
    userProfileData: {
        userProfiledata: {
            rowno: '',
            custcode: '',
            custname: '',
            emailid: '',
            phoneno: '',
            address1: '',
            address2: '',
            country: '',
            state: '',
            products: '',
            scanners: '',
            contactname: '',
            contactno: '',
            comments: '',
            dsoft: '',
            destination: '',
            tat: '',
            occlusion: '',
            contact: '',
            designtype: '',
            ponticdesign: '',
            modeltype: '',
            notes: '',
            isbatch: ''
        },
        designPref: [],
        designSoftwares: [],
        custtype: '',
        custname: '',
        custemail: '',
        custnumber: '',
        custaddressone: '',
        custaddresstwo: '',
        custcountry: '',
        custstate: '',
        custproduct: '',
        custscanner: '',
        custcontactName: '',
        custcontactNumber: '',
        custcomment: '',
        custdsoft: '',
        custdest: '',
        custtat: '',
        occlusion: '',
        contact: '',
        designtype: '',
        ponticdesign: '',
        modeltype: '',
        notes: '',

        occulsionArr: [],
        designtypeArr: [],
        contactArr: [],
        ponticdesignArr: [],
        modeltypeArr: []
    },
    userAccountData: {
        userAccountdata: [],
        addpusername: '',
        addnickname: '',
        addemail: '',
        addmobile: ''
    },
    signupUser: {},
    environment: {},
    errorState: {},
    feedback: {
        userFeedback: {
            transid: '',
            recid: '',
            ftype: '',
            status: '0',
            foption: ''
        },
        comments: '',
        rating: 0,
        submitFbFiles: [],
        General: [],
        Checked: [],
        Anterior: [],
        Copings: [],
        Model: [],
        Abutment: [],
        Cutback: [],
        fbtype: ''
    },
    fileUpload: {
        files2: [],
        materialfiles: '',
        filesUploaded: [],
        selectAll: false,
        progress: [],
        materialprogress: 0,
        progressSelected: [],
        orderDataDesign: [],
        orderDataTat: [],
        orderDataMaterial: [],
        orderDataManufacturer: [],
        orderDataBranch: [{
            rowno: '1',
            sbu_name: 'General'
        }],
        branchType: '0',
        saveMaterial: [],
        saveTat: [],
        saveDesign: [],
        saveMsg: [],
        sending: false
    },
    liveOrder: {
        newOrderData: [],
        liveOrderData: [],
        liveOrderDataOnHold: [],
        liveOrderDataReturned: [],
        cancelOrderData: [],
        orderno: '',
        orderid: '',
        viewOrderData: [{
            rowno: '',
            orderno: '',
            orderdate: '',
            fname: '',
            fpath: '',
            filesize: '',
            material: '',
            servicename: '',
            designtype: '',
            tat: '',
            msg: '',
            nounits: '',
            status: '',
            normal_smile_url: '',
            wide_smile_url: '',
            final_smile_url: '',
            final_scan_url: '',
            qc_rating: '',
            qc_remarks: '',
            normalsmilefile: '',
            widesmailfile: '',
            finalsmilefile: '',
            ds_ordersid: '',
            p_name: '',
            p_age: '',
            p_gender: '',
            qcuname: '',
            dueby: '',
            labname: ''
        }]
    },
    completeOrder: {
        completeOrderData: [],
        feedbackparameters: [],
        manucompleteOrderData: [],
        feedbacktypes: [],
        completeOrderDataDate: [],
        completeOrderDataExport: [],
        orderrawdata: [],
        orderrawdataExport: [],
        orderno: '',
        viewCompleteOrder: [
            {
                rowno: '',
                casenotes: '',
                orderno: '',
                orderdate: '',
                fname: '',
                fpath: '',
                filesize: '',
                feedback: '',
                servicename: '',
                designtype: '',
                tat: '',
                msg: '',
                nounits: '',
                status: '',
                customerstatus: '',
                vfiles: '',
                tool_preferred: '',
                qc_rating: '',
                qc_remarks: '',
                ds_ordersid: '',
                qcuname: '',
                dueby: '',
                labname: '',
                completedon: '',
                destination: '',
                modelonly: '',
                approval_reqd: '',
                bravopremium: '',
                designername: '',
                fqcname: '',
                mdesignername: '',
                fdownload: '',
                qc_required: '',
                downloadedon: '',
                refno: '',
                drpref: '',
            }
        ],
        viewFeedback: {
            orderno: '',
            feedbacktype: '',
            status: 0,
            rca: '',
            actionplan: '',
            comments: '',
            feedbackid: '',
            reviewstatus: '',
            attachments: [],
            params: [],
        },
        startDate: new Date(),
        endDate: new Date(),
        startDateRaw: new Date(),
        endDateRaw: new Date(),
        startTime: new Date(),
        endTime: new Date(),
        isDownloading: false,
        redesignReasons: [],
        redirectDesignReady: false,
        // dialog
        failedFiles: [],
        showFailedFilesDialog: false,
        failedFilesMessage: '',
    },
    forgotLink: {},
    forgotPassword: {},
    UserOrderData: {
        userOrderdata: {
            rowno: '',
            total: '',
            completed: '',
            returned: '',
            onhold: '',
            designready: '',
            completedcnt: ''
        },
        rowno: '',
        total: '',
        completed: '',
        returned: '',
        designready: '',
        onhold: '',
        items: [],
        greatest: '',
        completedcnt: ''
    },
    UserRxFormData: {
        userRxdata: [],
        designtype: '',
        notations: '',
        product: '',
        productname: '',
        model: '',
        getUserMessage: [],
        rowno: '',
        messageid: '',
        mfrom: '',
        mdate: '',
        message: '',
        attachmentname: '',
        attachfilename: '',
        createdon: '',
        messageattachmentsrow: '',
        messageFiles: [],
        getAttachementData: [],
        getFileData: [],
        signedUrlStl: []
    },
    support: {
        newSupport: {
            docid: '',
            dusername: '',
            supporttype: '',
            message: '',
            status: '',
            orderNo: ''
        },
        querytype: '',
        messageFilesSupp: [],
        getAttachmentData: [],
        docid: '',
        orderNo: '',
        ordernoDisabled: false,
        supportExportData: []
    },
    supportPage: {
        newSupport: {
            messagetype: '',
            message: '',
            caseno: '',
            refmessageid: '',
        },
        getSupportMessage: [],
        messageFiles: [],
        getSupportAttachmentData: [],
        statustype: ''
    },
    landingPage: {
        searchName: '',
        searchValue: [],
        searchTrue: false,
        searchLoading: false,
        searchType: '',
        notifications: [],
        notificationCount: 0,
        openVideoPlayer: false,
        videoSignedUrl: [],
        loader: false,
        verticalViewScreen: false
    },
    supportRequest: {
        supportRequestData: [],
        ticketno: '',
        date: '',
        supporttype: '',
        status: '',
        mtype: '',
        caseno: '',
        supportRequestTypes: []
    },
    feedbackRequest: {
        feedbackTypes: [],
        createdon: '',
        designapproval: '',
        destination: '',
        feedbacktype: '',
        fname: '',
        orderno: '',
        rating: '',
        reviewcomments: '',
        rowno: '',
        tool_preferred: ''
    },
    payment: {
        getPaymentData: [],
        invoiceData: [],
        isWaiting: false,
        paymentId: '',
        returnTransactionId: '',
        returnTransactionStatus: false,
        paymentStatus: '',
        txnid: '',
        txnamt: '',
        axperror: '',
        startPDate: new Date(),
        endPDate: new Date(),
        startPTime: new Date(),
        endPTime: new Date(),
        // paymentAmount: 0,
        // unitTotal: 0
    },
    paidInvoice: {
        getPaidInvoiceData: [],
        myInvoicesData: []
    },
    editDesignPreferences: {
        designPreferencesData: [],
        custDPrefData: [],
        custDPrefDataInitial: [],
        materialFilesData: [],
    },
    materialFiles: {
        materialFilesData: [],
    },
    manufactur: {
        underDesignData: [],
        designReadyData: [],
        mHoldOrderData: [],
        mNewOrderData: [],
        mInproductionOrderData: [],
        mCompleteOrderData: [],
        mfilteredOrderData: [],
        mfilterLessOrderData: [],
        mfiltersdataExport: [],
        previewOrderData: {
            userRxdata: [],
            getUserMessage: [],
            getFileData: [],
            caseNotes: ''
        }
    },
    mfileupload: {
        mfilesUpload: [],
        mprogress: [],
        mbranchData: [],
        mbranchType: '0',
        mlabData: [],
        mlabChosen: '0',
        msending: false
    }
});



// WEBPACK FOOTER //
// ./src/redux.tsx